import React from 'react'
import { objectOf, func, string } from 'prop-types'
import './BrandAndShipClassFilter.scss'
import SelectWithLabel from '../SelectWithLabel/SelectWithLabel'

const BrandAndShipClassFilter = ({
  brands,
  shipClasses,
  voyageTypes,
  selectedBrand,
  selectedShipClass,
  selectedVoyage,
  onNewBrand,
  onNewShipClass,
  onNewVoyageType,
}) => {
  return (
    <div className="list-filters-wrapper">
      <div className="list-filters">
        <SelectWithLabel
          placeholder="All Cruises"
          label="Cruise Type"
          values={voyageTypes}
          selectedValue={selectedVoyage}
          onChange={onNewVoyageType}
        />
        <SelectWithLabel
          placeholder="All Brands"
          label="Brand"
          values={brands}
          selectedValue={selectedBrand}
          onChange={onNewBrand}
        />
        <SelectWithLabel
          placeholder="All Classes"
          label="Ship Class"
          values={shipClasses}
          selectedValue={selectedShipClass}
          onChange={onNewShipClass}
        />
      </div>
    </div>
  )
}

BrandAndShipClassFilter.propTypes = {
  brands: objectOf(Object).isRequired,
  voyageTypes: objectOf(Object).isRequired,
  shipClasses: objectOf(Object).isRequired,
  selectedBrand: string,
  selectedVoyage: string,
  selectedShipClass: string,
  onNewBrand: func.isRequired,
  onNewVoyageType: func.isRequired,
  onNewShipClass: func.isRequired,
}

BrandAndShipClassFilter.defaultProps = {
  selectedBrand: null,
  selectedShipClass: null,
  selectedVoyage: null,
}

export default BrandAndShipClassFilter
